<template>
    <div class="container">
        广播分发
    </div>
</template>


<script>
export default {
  name:"broadcast",
  data() {
    return {};
  }
};
</script>


<style lang="less" scoped>
.container {
  height: calc(100% - 65px);
  background-color: #808080;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 40px;
  color: white;
}
</style>
